import { useSelector } from "react-redux";
import { usersInitialState, usersSelector } from "./usersReducer";

export function useUsersByWallet() {
    const { usersByWallet } = useSelector(usersSelector) || usersInitialState;
    return usersByWallet;
}
